import http from "../http";

export const getCart = (storeId) => {
  return http.get(`/store-management/cart/?store_id=${storeId}`);
};

export const saveStoreCard = (data) => {
  return http.post(`/store-management/cart/`, data);
};

export const editCart = (storeId, data) => {
  return http.patch(`/store-management/cart/?store_id=${storeId}`, data);
};
